import { useEffect } from 'react';
import { supabase } from '@/lib/supabase';

const VIEW_DEDUP_WINDOW_MS = 15_000;

interface PublicViewTrackerProps {
  postId?: string | null;
  enabled?: boolean;
}

export function PublicViewTracker({ postId, enabled = true }: PublicViewTrackerProps) {
  useEffect(() => {
    if (!postId || !enabled) return;

    const storageKey = `lumenise:view:last:${postId}`;
    const lastView = Number(window.sessionStorage.getItem(storageKey) ?? 0);
    if (lastView && Date.now() - lastView < VIEW_DEDUP_WINDOW_MS) return;

    void (async () => {
      try {
        const { error } = await supabase.rpc('increment_post_view', { input_post_id: postId });
        if (!error) window.sessionStorage.setItem(storageKey, String(Date.now()));
        if (error && import.meta.env.DEV) console.warn('Erro ao registrar visualização', error);
      } catch (error) {
        if (import.meta.env.DEV) console.warn('Erro ao registrar visualização', error);
      }
    })();
  }, [enabled, postId]);

  return null;
}
